import BarColumn from "./BarColumn"
export default BarColumn
